import {HttpRequest,HttpMethod} from "./http";

class UserProvider extends HttpRequest {

	// CRUD User
	UserCreate(params){
		return this.request(HttpMethod.Post,`/api/v1/admin/users`,params );
	}

	UserList(params){
		return this.request(HttpMethod.Get,`/api/v1/users`,params );
	}

	UserUpdate(id,params){
		return this.request(HttpMethod.Put,`/api/v1/admin/users/${id}`,params );
	}

	UserDelete(id){
		return this.request(HttpMethod.Delete,`/api/v1/admin/users/${id}`);
	}

	// Change User Status
	ChangeUserStatus(id,params){
		return this.request(HttpMethod.Put,`/api/v1/users/${id}/status`,params );
	}

	// Change User Role
	ChangeUserRole(id,params){
		return this.request(HttpMethod.Put,`/api/v1/users/${id}/role`,params );
	}

	// Change User Password
	ChangeUserPassword(params){
		return this.request(HttpMethod.Put,`/api/v1/users/password`,params );
	}

	ChangeUserPasswordByAdmin(id,params){
		return this.request(HttpMethod.Put,`/api/v1/admin/users/password/${id}`,params );
	}






}

export default UserProvider